import { Record } from 'immutable';

// Marking all fields on the association definition as optional is not the best type
// here, but it should be fine to maintain existing behavior when using the immutable
const AssociationRecord = Record({
  cardinality: undefined,
  category: undefined,
  fromObjectType: undefined,
  fromObjectTypeId: undefined,
  hasAllAssociatedObjects: undefined,
  id: undefined,
  inverseId: undefined,
  inverseLabel: undefined,
  isPrimary: undefined,
  isInversePrimary: undefined,
  label: undefined,
  maxToObjectIds: undefined,
  name: undefined,
  toObjectType: undefined,
  toObjectTypeId: undefined
}, 'AssociationRecord');
AssociationRecord.fromJS = json => {
  if (!json || typeof json !== 'object') {
    return json;
  }
  return AssociationRecord(json);
};
export default AssociationRecord;